/* Cooked shopping layer (2026-09-10): quick add from any product card, "Complete the fit"
   in the cart drawer, shop-the-look hotspots, PDP lightbox + thumbnail rail, drag rails. */
(function () {
  'use strict';
  var routes = window.routes || {};

  function addToCart(variantId, btn) {
    var drawer = document.querySelector('cart-drawer');
    var fd = new FormData();
    fd.append('id', variantId); fd.append('quantity', 1);
    if (drawer && typeof drawer.renderContents === 'function') {
      fd.append('sections', 'cart-drawer,cart-icon-bubble');
      fd.append('sections_url', window.location.pathname);
    }
    if (btn) { btn.classList.add('is-busy'); btn.setAttribute('aria-busy', 'true'); }
    return fetch(routes.cart_add_url || '/cart/add', {
      method: 'POST',
      headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) throw new Error(data.description || data.message || 'Could not add to bag');
        if (drawer && data.sections) { drawer.renderContents(data); }
        else if (drawer) { drawer.open(); }
        else { window.location.href = routes.cart_url || '/cart'; }
        document.dispatchEvent(new CustomEvent('cart:updated'));
        document.querySelectorAll('.cooked-product-card.qa-open').forEach(function (c) { c.classList.remove('qa-open'); });
        document.querySelectorAll('[data-cooked-hotspot].is-open').forEach(function (h) { h.classList.remove('is-open'); });
        if (btn) { btn.classList.add('is-added'); setTimeout(function () { btn.classList.remove('is-added'); }, 1600); }
      })
      .catch(function (err) {
        if (btn) { btn.classList.add('is-error'); setTimeout(function () { btn.classList.remove('is-error'); }, 2000); }
        if (window.console) console.warn('[cooked] add failed', err);
      })
      .then(function () { if (btn) { btn.classList.remove('is-busy'); btn.removeAttribute('aria-busy'); } });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var toggle = t.closest('[data-cooked-qa-toggle]');
    if (toggle) {
      e.preventDefault(); e.stopPropagation();
      var card = toggle.closest('.cooked-product-card');
      document.querySelectorAll('.cooked-product-card.qa-open').forEach(function (c) { if (c !== card) c.classList.remove('qa-open'); });
      card.classList.toggle('qa-open');
      return;
    }
    var add = t.closest('[data-cooked-qa-add]');
    if (add) { e.preventDefault(); e.stopPropagation(); addToCart(add.getAttribute('data-variant-id'), add); return; }

    var up = t.closest('[data-cooked-upsell-add]');
    if (up) {
      e.preventDefault();
      var wrap = up.closest('[data-cooked-upsell]');
      var sel = wrap ? wrap.querySelector('select') : null;
      if (sel) addToCart(sel.value, up);
      return;
    }

    var dot = t.closest('[data-cooked-hotspot-dot]');
    if (dot) {
      e.preventDefault(); e.stopPropagation();
      var hs = dot.closest('[data-cooked-hotspot]');
      var open = hs.classList.contains('is-open');
      document.querySelectorAll('[data-cooked-hotspot].is-open').forEach(function (h) { h.classList.remove('is-open'); });
      if (!open) hs.classList.add('is-open');
      return;
    }
    var closeHs = t.closest('[data-cooked-hotspot-close]');
    if (closeHs) { e.preventDefault(); closeHs.closest('[data-cooked-hotspot]').classList.remove('is-open'); return; }

    if (!t.closest('[data-cooked-hotspot]')) document.querySelectorAll('[data-cooked-hotspot].is-open').forEach(function (h) { h.classList.remove('is-open'); });
    if (!t.closest('.cooked-product-card')) document.querySelectorAll('.cooked-product-card.qa-open').forEach(function (c) { c.classList.remove('qa-open'); });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-cooked-hotspot].is-open').forEach(function (h) { h.classList.remove('is-open'); });
    document.querySelectorAll('.cooked-product-card.qa-open').forEach(function (c) { c.classList.remove('qa-open'); });
  });

  /* ---------- PDP lightbox + thumbnail rail ---------- */
  function setupLightbox() {
    var gallery = document.querySelector('[data-cooked-gallery]');
    var dlg = document.getElementById('cooked-lb');
    if (!gallery || !dlg || typeof dlg.showModal !== 'function') return;
    var imgs = Array.prototype.slice.call(gallery.querySelectorAll('.cooked-pdp__media-item .cooked-pdp__img'));
    if (!imgs.length) return;
    var stage = dlg.querySelector('[data-lb-stage]');
    var counter = dlg.querySelector('[data-lb-count]');
    var idx = 0;

    function bigSrc(img) {
      var src = img.currentSrc || img.src || '';
      if (/([?&])width=\d+/.test(src)) return src.replace(/([?&])width=\d+/, '$1width=2000');
      return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=2000';
    }
    function show(i) {
      idx = (i + imgs.length) % imgs.length;
      stage.innerHTML = '';
      var im = new Image();
      im.src = bigSrc(imgs[idx]); im.alt = imgs[idx].alt || ''; im.className = 'cooked-lb__img'; im.draggable = false;
      im.addEventListener('click', function (ev) {
        var zoomed = im.classList.toggle('is-zoomed');
        if (zoomed) {
          var r = im.getBoundingClientRect();
          im.style.transformOrigin = ((ev.clientX - r.left) / r.width * 100).toFixed(1) + '% ' + ((ev.clientY - r.top) / r.height * 100).toFixed(1) + '%';
        }
      });
      stage.appendChild(im);
      if (counter) counter.textContent = (idx + 1) + ' / ' + imgs.length;
    }
    imgs.forEach(function (img, i) {
      var fig = img.closest('.cooked-pdp__media-item');
      fig.addEventListener('click', function () { show(i); dlg.showModal(); document.body.classList.add('lb-open'); });
    });
    dlg.addEventListener('click', function (e) {
      var b = e.target.closest('[data-lb]');
      if (b) { var k = b.getAttribute('data-lb'); if (k === 'close') dlg.close(); else if (k === 'prev') show(idx - 1); else if (k === 'next') show(idx + 1); return; }
      if (e.target === dlg || e.target === stage) dlg.close();
    });
    dlg.addEventListener('close', function () { document.body.classList.remove('lb-open'); });
    document.addEventListener('keydown', function (e) {
      if (!dlg.open) return;
      if (e.key === 'ArrowRight') show(idx + 1);
      if (e.key === 'ArrowLeft') show(idx - 1);
    });
    var sx = null;
    dlg.addEventListener('touchstart', function (e) { if (e.touches.length === 1) sx = e.touches[0].clientX; }, { passive: true });
    dlg.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) > 50) show(idx + (dx < 0 ? 1 : -1));
      sx = null;
    }, { passive: true });

    var thumbs = Array.prototype.slice.call(document.querySelectorAll('[data-cooked-thumb]'));
    if (thumbs.length) {
      thumbs.forEach(function (th, i) {
        th.addEventListener('click', function () {
          var fig = imgs[i] && imgs[i].closest('.cooked-pdp__media-item');
          if (!fig) return;
          var y = fig.getBoundingClientRect().top + window.scrollY - 110;
          window.scrollTo({ top: y, behavior: 'smooth' });
        });
      });
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (!en.isIntersecting) return;
            var i = imgs.indexOf(en.target.querySelector('.cooked-pdp__img'));
            thumbs.forEach(function (th, j) { th.classList.toggle('is-active', j === i); });
          });
        }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });
        imgs.forEach(function (img) { io.observe(img.closest('.cooked-pdp__media-item')); });
      }
    }
  }

  /* ---------- Drag-to-scroll rails (meanings scroller) ---------- */
  function setupRails() {
    document.querySelectorAll('[data-cooked-rail]').forEach(function (rail) {
      var down = false, moved = false, sx = 0, sl = 0;
      rail.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        down = true; moved = false; sx = e.clientX; sl = rail.scrollLeft; rail.classList.add('is-drag');
      });
      window.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - sx;
        if (Math.abs(dx) > 6) moved = true;
        rail.scrollLeft = sl - dx;
      });
      window.addEventListener('pointerup', function () { if (!down) return; down = false; rail.classList.remove('is-drag'); });
      rail.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
      var host = rail.parentElement;
      var prev = host.querySelector('[data-rail-prev]'), next = host.querySelector('[data-rail-next]');
      function step(d) {
        var panel = rail.querySelector('.cooked-meanings__panel');
        rail.scrollBy({ left: d * (panel ? panel.offsetWidth + 24 : 420), behavior: 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
    });
  }

  function ready(fn) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, { once: true }); else fn(); }
  ready(function () { setupLightbox(); setupRails(); });
})();